const ticker = document.querySelector('[data-ticker="list"]');
const tickerItems = document.querySelectorAll('[data-ticker="item"]');
let viewportWidth = 0;
let paused = false;

function setupViewport() {
    // Duplicate the items twice for a seamless loop
    tickerItems.forEach(item => {
        ticker.appendChild(item.cloneNode(true));
    });

    // Calculate total width of one set
    tickerItems.forEach(item => {
        viewportWidth += item.offsetWidth;
    });

    // Total width is now double for the duplicated set
    ticker.style.width = (viewportWidth * 4) + 'px';
}

function animateTicker() {
    let lastTime = null;
    let currentX = 0;
    const speed = 50; // pixels per second

    function step(timestamp) {
        if (!lastTime) lastTime = timestamp;
        let deltaTime = (timestamp - lastTime) / 1000; // seconds
        lastTime = timestamp;

        if (!paused) {
            currentX += speed * deltaTime;
            ticker.style.transform = `translateX(${-currentX % viewportWidth}px)`;
        }

        requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

function initializeTicker() {
    setupViewport();
    animateTicker();

    ticker.addEventListener('mouseenter', () => paused = true);
    ticker.addEventListener('mouseleave', () => paused = false);
}

initializeTicker();